import { render, staticRenderFns } from "./tan_needGz_portrait_isHaveChange.vue?vue&type=template&id=3f44aeed&scoped=true"
import script from "./tan_needGz_portrait_isHaveChange.vue?vue&type=script&lang=js"
export * from "./tan_needGz_portrait_isHaveChange.vue?vue&type=script&lang=js"
import style0 from "./tan_needGz_portrait_isHaveChange.vue?vue&type=style&index=0&id=3f44aeed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f44aeed",
  null
  
)

export default component.exports